import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export function useSpotAvailableAtPort(portCountryCode?: string, testOrder: boolean = false, enabled: boolean = true) {
    return useQuery({
        ...queries.supplierGroups.spotAvailability(portCountryCode!!, testOrder),
        enabled: enabled && !!portCountryCode,
    });
}
